<template>
  <div class="header">
    <div class="headerWidth">
      <div class="userinfoAndComponeyname">
        <div class="userinfo l" @click="goToHomePage" style="margin-top:12px">
            <img src="../assets/images/Logo_.jpg" :alt="$t('messages.top_img')">
        </div>
        <div class="l componeyname" @click="goToHomePage" >
          <span>譯友</span>
        </div>
      </div>
      <span class="smallElMenu" style="display: none;">
        <el-menu default-active="1" ref="elMenu" class="el-menu-demo" mode="vertical" @select="handleSelect" theme="light" :default-openeds="openList">
          <el-submenu index="">
            <template slot="title" class="iconMenu"><i class="el-icon-menu"></i></template>
            <el-submenu index="1">
              <template slot="title">WHY YIYO</template>
              <el-menu-item index="1-1">Product Features</el-menu-item>
              <el-menu-item index="1-2">WHY YIYO</el-menu-item>
            </el-submenu>
            <el-submenu index="2">
              <template slot="title">SOLUTIONS</template>
              <el-menu-item index="2-1">For Translators</el-menu-item>
              <el-menu-item index="2-2">For Teams</el-menu-item>
              <el-menu-item index="2-3">For Enterprises</el-menu-item>
            </el-submenu>
            <el-menu-item index="3">PRICING</el-menu-item>
            <el-menu-item index="4">ABOUT</el-menu-item>
          </el-submenu>
        </el-menu>
      </span>
      <span class="bigElMenu">
        <el-menu default-active="1" ref="elMenu" class="el-menu-demo" mode="horizontal"  @select="handleSelect" theme="light">
          <el-submenu index="1">
            <template slot="title">WHY YIYO</template>
            <el-menu-item index="1-1">Product Features</el-menu-item>
            <el-menu-item index="1-2">WHY YIYO</el-menu-item>
          </el-submenu>
          <el-submenu index="2">
            <template slot="title">SOLUTIONS</template>
            <el-menu-item index="2-1">For Translators</el-menu-item>
            <el-menu-item index="2-2">For Teams</el-menu-item>
            <el-menu-item index="2-3">For Enterprises</el-menu-item>
          </el-submenu>
          <el-menu-item index="3">PRICING</el-menu-item>
          <el-menu-item index="4">ABOUT</el-menu-item>
        </el-menu>
      </span>
      <div class=" r">
        <div class="changeLanguage l">
          <a :href="fileUrl" download="YIYO.msi" target="_blank"><el-button :plain="true" >GET STARTED</el-button></a>
            <!-- <a download="YIYO.exe" target="_blank"><el-button :plain="true"  @click="openPasswordDialog">GET STARTED</el-button></a> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState,mapMutations} from 'vuex'
export default {
  name: 'top',
  data () {
    return {
      msg: '',
      lang:'zh-CN',
      isSmallScreen: false,
      fileUrl:'https://yiyo-static-new.oss-cn-hangzhou.aliyuncs.com/setup.msi',
      openList: [],
    }
  },
  mounted: function () {
    this.$nextTick(function () {

      if(!this.email) {
        this.setEmail(window.localStorage.getItem('email'));
        var lang = localStorage.getItem('lang') || 'zh-CN';
        this.$i18n.locale = lang;  
      }
      this.goToHomePage();
    })
  },
  watch:{
  },
  computed: {
    ...mapState(['email'])
  },
  methods: {
    handleSelect(key, keyPath) {
      var menuPath = '';
      // keyPath.forEach((element) => {
      //   menuPath += this.menuNames['_'+element] + ' > ';
      // }, this);
      // console.log(menuPath.substring(0,menuPath.length-3));
      this.openList = [];
      console.log(key,keyPath)
      this.setMenuPath(menuPath.substring(0,menuPath.length-3));
      this.setMenuPathKeys(keyPath);
      this.setMenuClickParam(key+ ',' + Math.random());
    },
    goToHomePage(){
      this.openList = [];
      this.$refs.elMenu.activeIndex = null
      this.setMenuPathKeys(["1","1-0"]);
      this.setMenuClickParam( '1-0,' + Math.random());
    },
    ...mapMutations(['setMenuPath','setMenuPathKeys','setMenuClickParam','setEmail','openPasswordDialog']),
    changeLanguageToEn:function(){
      this.lang=this.$i18n.locale;
      // console.log(this.lang);
       if ( this.lang == 'zh-CN' ) {
          this.lang = 'en-US';
          this.$i18n.locale = this.lang;
          window.localStorage.setItem('lang',this.lang)
        }
     },
     changeLanguageToZh:function(){
      console.log(123)
      this.lang=this.$i18n.locale;
      // console.log(this.lang);
       if ( this.lang == 'en-US' ) {
          this.lang = 'zh-CN';
          this.$i18n.locale = this.lang;
          window.localStorage.setItem('lang',this.lang)
        }
     },
     openPasswordDialog(){
      console.log('2344')
      this.$emit('openPasswordDialog',this.fileUrl)
     },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

.header {
  position: fixed; 
  z-index: 999;
  top:0;
  left:0;
  /*line-height:50px;*/
  width:100%;
  height:80px;
  background:#FFFFFF;
  font-size:16px;
  font-weight: bold;
  color:#DDD;
}
.header .headerWidth{
  max-width: 1500px;
  height: 100%;
  margin: 0 auto;
  padding: 0 20px;
  /*display: flex;
  justify-content: center;
  align-items: center;*/
}
.header .userinfoAndComponeyname{
  /*flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;*/
  float: left;
}
.header .userinfo img{
  /*position: absolute;
  width: 37px;
  height: 55px;
  left: 42px;
  top: 33px;*/
  width: 37px;
  height: 55px;
}
.header .userinfo img:hover{
  cursor:pointer;
}
.header .componeyname span:hover{
  cursor:pointer;
}
.header .componeyname{
  /*position: absolute;
  width: 99px;
  height: 67px;
  left: 86px;
  top: 27px;
  font-style: normal;
  font-weight: 200;
  font-size: 48px;
  line-height: 67px;
  text-align: center;

  color: #222222;*/
  width: 99px;
  height: 67px;
  font-style: normal;
  font-weight: 200;
  font-size: 48px;
  line-height: 67px;
  text-align: center;
  color: #222222;
  margin-top:5px;
}
.header .headerWidth .bigElMenu{
  width: calc(100% - 300px);
    /* margin-left: 136px; */
    height: 80px;
    display: inline-block;
    margin-top:15px;
}
.header .headerWidth .bigElMenu .el-menu { 
  /*position: absolute;
  width: 504px;
  height: 20px;
  left: 229px;
  top: 50px;*/
  width: 100%;
  height: 20px;
}
.header .headerWidth .el-menu-item{
     padding:0 20px !important;
  }
.header .headerWidth .el-submenu .el-submenu .el-menu-item{
   padding:0 40px !important;
}

.header .headerWidth .el-submenu__title{
   padding:0 20px !important;
   height:50px;
   line-height:50px;
}
.header .el-submenu__title{
  padding:0 35px;
  text-align:left;
  height:50px;
  line-height:50px;
}
.el-menu--horizontal{
  top:60px !important;
}
.header .headerWidth .bigElMenu .el-menu--horizontal{
  border:0;
  top:0 !important;
}
.header .headerWidth .el-menu-item{
  height:50px;
  line-height:50px;
  text-align:left;
}
.header .headerWidth .el-menu--horizontal>.el-submenu .el-submenu__title{
  height:50px !important;
  line-height:50px !important;
  border:0;
  text-align:left;
}
.header .el-menu-item-group__title{
  height:50px;
  line-height:50px;
  text-align:left;
  padding: inherit;
}
.header .headerWidth .bigElMenu .el-menu--horizontal>.el-submenu.is-active .el-submenu__title{
  border:0;
}
.header .headerWidth .bigElMenu .el-menu--horizontal>.el-menu-item.is-active{
  border:0;
}
.header .r{
  flex-grow: 1;
}
.header .changeLanguage { 
  /*margin-right: 200px;*/
  margin-top: 14px;
}
.header .changeLanguage .el-button{
  /*display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px 24px;

  position: absolute;
  width: 164px;
  height: 52px;
  top: 34px;
  color:#000;
  border: 1px solid #222222;
  box-sizing: border-box;
  border-radius: 10px;*/
  padding: 16px 24px;
  width: 164px;
  height: 52px;
  color:#000;
  border: 1px solid #222222;
  box-sizing: border-box;
  border-radius: 10px;
  float: left;
}
.header .changeLanguage .el-button:hover{
  background:#fff;
  border-color:#8492A6 !important;
  color:#8492A6;
}
.header .changeLanguage .el-button span{    
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.03em;
}

@media only screen and (max-width: 825px){
  .header .userinfo img{
    width: 27px!important;
    height: 40px!important;
    margin-top: 8px;
  }
  .header .componeyname{
    font-size: 26px!important;
    width: 65px!important;
  }
  .header .r{margin-top:20px;}
  .header .headerWidth {
    padding: 0 10px !important;
  }
  /*.header .changeLanguage .el-button{
    width: 80px!important;
    height: 40px!important;
    padding: 0 5px !important;
    text-align:center;
  }
  .header .changeLanguage .el-button span{
    font-size: 10px!important;
  }
  .header .headerWidth .smallElMenu {
    float: left;
    width: calc(100% - 190px) !important;
    max-width: 250px;
    margin-top: 15px;
    margin-left: 0 !important;
  }*/
  .header .headerWidth .el-menu-item{
     padding:0 10px !important;
     border-bottom: 1px solid #eee;
     color:#909399 !important;
  }
  .header .headerWidth .el-submenu .el-submenu .el-menu-item{
     padding:0 20px !important;
  }

  .header .headerWidth .el-submenu__title{
     padding:0 10px !important;
     height:50px;
     line-height:50px;
     border-bottom: 1px solid #eee;
     color:#909399 !important;
     text-align:left;
  }
  .header .headerWidth  .el-icon-menu{color:#000 !important;}
  .header .headerWidth .el-submenu__title:first-child{
     border-bottom: 0;
  }
  .header .headerWidth .is-opened .el-submenu__title:first-child{
     border-bottom: 1px solid #eee;
  }
  .header .headerWidth .bigElMenu, .r{
    display: none !important;
  }
  .header .headerWidth .smallElMenu{
    float: right;
    width: calc(100% - 100px);
    /*max-width: 250px;
    margin-left:10px;*/
    margin-top:15px;
    display: inline-block !important;
  }
  .header .headerWidth .smallElMenu .el-menu{
    border-right: none;
  }
  .is-opened{width:100% !important;}
  .header .el-icon-menu{
    float: right;
    margin-right: 25px;
    margin-top: 16px;
  }
  .header .headerWidth .el-submenu__title:hover, .el-submenu__title:focus, .el-menu-item:focus, .el-menu-item:hover{
    background-color: #fff !important;
  }/**/
}
  
</style>



// WEBPACK FOOTER //
// src/components/Top.vue